<template>
  <div v-if="!!phaseData && isMounted">
    <template v-for="anxietyDepressionOption in anxietyDepressionOptions">
      <field-label :label="anxietyDepressionOption.name" :key="anxietyDepressionOption.key">
        <v-radio-group
          row
          class="mt-3"
          v-model="phaseData.anxiety_depression[anxietyDepressionOption.key].value"
          @change="resetObject(anxietyDepressionOption.key)"
          :required="anxietyDepressionOption.required"
        >
          <v-radio
            v-for="option in anxietyDepressionOption.options"
            :key="option.value"
            :label="option.text"
            :value="option.value"
            :required="option.required"
            clearable
          />
        </v-radio-group>
        <field-label
          v-if="
            (phaseData.anxiety_depression[anxietyDepressionOption.key].value === 'SIM' ||
              phaseData.anxiety_depression[anxietyDepressionOption.key].value === true) &&
            anxietyDepressionOption.next_question
          "
          :label="anxietyDepressionOption.next_question.name"
          class="ml-3"
        >
          <v-row>
            <v-col cols="12" class="mb-0 py-0">
              <v-radio-group
                row
                class="mt-3"
                v-if="anxietyDepressionOption.key === 'anxiety_depression'"
                v-model="phaseData.anxiety_depression[anxietyDepressionOption.key].take_medicine"
                hide-details
                :rules="anxietyDepressionOption.required ? [$validation.radioRequired()] : []"
                :required="anxietyDepressionOption.required"
              >
                <v-radio
                  v-for="next_option in anxietyDepressionOption.next_question.options"
                  :key="next_option.value"
                  :label="next_option.text"
                  :value="next_option.value"
                  :rules="anxietyDepressionOption.required ? [$validation.radioRequired()] : []"
                  :required="next_option.required"
                />
              </v-radio-group>
            </v-col>
            <v-col cols="6" class="mt-6 py-0">
              <v-text-field
                v-if="phaseData.anxiety_depression[anxietyDepressionOption.key].take_medicine"
                v-model="phaseData.anxiety_depression[anxietyDepressionOption.key].medicine"
                label="Qual?"
                outlined
              />
            </v-col>
          </v-row>
          <div class="d-flex" v-if="anxietyDepressionOption.key === 'attendance'">
            <v-checkbox
              class="mt-0 mr-3"
              v-for="next_option in anxietyDepressionOption.next_question.options"
              :key="next_option.value"
              :label="next_option.text"
              :value="next_option.value"
              v-model="phaseData.anxiety_depression[anxietyDepressionOption.key].selected"
              @change="resetTextField(anxietyDepressionOption.key)"
            />
          </div>
          <div v-if="anxietyDepressionOption.key === 'attendance'">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-if="phaseData.anxiety_depression[anxietyDepressionOption.key].selected.includes('outro')"
                  v-model="phaseData.anxiety_depression[anxietyDepressionOption.key].other"
                  label="Qual?"
                  outlined
                />
              </v-col>
            </v-row>
          </div>
        </field-label>
        <div
          v-if="
            phaseData.anxiety_depression[anxietyDepressionOption.key].value &&
            anxietyDepressionOption.key === 'support_group'
          "
          class="ml-3"
        >
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="phaseData.anxiety_depression[anxietyDepressionOption.key].group"
                label="Qual?"
                outlined
                :required="attendance.data.summarizedFlow"
              />
            </v-col>
          </v-row>
        </div>
      </field-label>
    </template>
    <template v-for="profileOption in profileOptions">
      <section class="mb-10" :key="`section-${profileOption.section.key}`">
        <header>
          <h2>{{ profileOption.section.name }}</h2>
        </header>
        <div>
          <radio-options
            class="mt-4"
            v-for="option in profileOption.options"
            :key="`profile-${option.key}`"
            :label="option.name"
            v-model="phaseData.profile[option.key].value"
            row
            clearable
            hide-details
            :options="defaultProfileOptions"
          />
        </div>
      </section>
    </template>

    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" />
    </field-label>
  </div>
</template>
<script>
import FieldLabel from '@/components/FieldLabel.vue'
import RadioOptions from '@/components/RadioOptions.vue'
import TextArea from '@/components/TextArea.vue'
import BasePhase from './BasePhase.vue'

import {
  PROFESSIONAL_OPTIONS,
  PSYCHIATRIC_SCREENING_PERIODICITY,
  ANXIETY_DEPRESSION_OPTIONS,
  ANXIETY_DEPRESSION_OPTIONS_SUMMARIZED,
  PROFILE_OPTIONS,
} from '@/components/AttendanceForm/general/constants/psychiatricScreening'

import { createNamespacedHelpers } from 'vuex'
import { DISEASES } from '@/constants/disease'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  components: { FieldLabel, TextArea, RadioOptions },
  extends: BasePhase,
  computed: {
    ...attendanceGettersMap(['attendance', 'attendanceDiseaseId']),
    defaultProfileOptions() {
      return PSYCHIATRIC_SCREENING_PERIODICITY
    },

    anxietyDepressionOptions() {
      return this.attendance?.data?.summarizedFlow && this.attendanceDiseaseId === DISEASES.ATOPIC_DERMATITIS
        ? ANXIETY_DEPRESSION_OPTIONS_SUMMARIZED
        : ANXIETY_DEPRESSION_OPTIONS.filter((option) => !this.attendance.data.summarizedFlow || option.required)
    },

    profileOptions() {
      return PROFILE_OPTIONS.filter((option) => !this.attendance.data.summarizedFlow || option.required)
    },
  },
  data() {
    return {
      isMounted: false,
    }
  },
  methods: {
    getDefaultData() {
      const data = {
        anxiety_depression: this.buildAnxietyProfile(),
        profile: this.buildEmptyProfile(),
        notes: null,
      }
      return data
    },
    buildAnxietyProfile() {
      return {
        anxiety_depression: {
          value: null,
          take_medicine: null,
          medicine: null,
        },
        attendance: {
          value: null,
          selected: [],
          other: null,
        },
        support_group: {
          value: null,
          group: null,
        },
      }
    },
    buildEmptyProfile() {
      return PROFILE_OPTIONS.map((profileOption) => profileOption.options)
        .flat()
        .reduce((acc, option) => ({ ...acc, [option.key]: { value: null } }), {})
    },
    postPhaseDataLoaded() {
      if (!this.phaseData.anxiety_depression) this.phaseData.anxiety_depression = this.buildAnxietyProfile()
      this.isMounted = true
    },
    resetObject(key) {
      if (
        this.phaseData.anxiety_depression[key].value === false ||
        this.phaseData.anxiety_depression[key].value === 'NAO' ||
        this.phaseData.anxiety_depression[key].value === 'NAO_SEI'
      ) {
        for (let param in this.phaseData.anxiety_depression[key]) {
          if (!(param === 'value')) {
            Array.isArray(this.phaseData.anxiety_depression[key][param])
              ? (this.phaseData.anxiety_depression[key][param] = [])
              : (this.phaseData.anxiety_depression[key][param] = null)
          }
        }
      }
    },
    resetTextField(key) {
      if (!this.phaseData.anxiety_depression[key].selected.includes('outro')) {
        this.phaseData.anxiety_depression[key].other = null
      }
    },
  },
}
</script>

<style scoped></style>
